/**
* @author ZhanFuzheng
* @date 2022/07/14
* @time 16:13
* @update 2022/09/05 ZhanFuzheng 灯光仿真页面 新增 支付流程
* @update 2023/04/26 ZhanFuzheng 新增轮播突破
*/
<template>
<div>
    <div id="wrapper" :class="['wrapper-open',iphonePayCourseVisible && 'no-scroll']">
        <!--头部-->
        <template v-if="!H5 && headVisible !== '0'">
            <div class="header">
                <div class="header-left" @click="goBack"><img src="@/assets/vip/icon_back1.png" alt=""/></div>
                <div class="header-main" >科三灯光仿真训练</div>
                <div class="header-share" v-if="shareVisible" @click="openSharePanel"><img src="@/assets/public/icon_fx01.png" alt=""></div>
                <div class="header-right" v-if="!H5" @click="pushCusService"><img src="@/assets/vip/icon_customerservice1.png" alt=""></div>
            </div>
            <!--头部占位-->
            <div class="header-pre"></div>
        </template>

        <!--分享框架-->
        <share-ad :detail="shareData">
            <div class="detail">
                <div class="swiper-image">
                    <swiper class="swiper" ref="swiper" :options="swiperOptions">
                        <swiper-slide v-for="(imagePath, index) in carItems" :key="index">
                            <div class="swiper-item">
                                <img class="item-img" :src="imagePath" />
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>
                <div class="loop-image">
                    <van-swipe class="my-swipe" :autoplay="5000" indicator-color="white">
                        <van-swipe-item v-for="(item, index) in loopImages" :key="index" @click="preview(index)"><img class="detail-image" :src="item" /></van-swipe-item>
                    </van-swipe>
                </div>
                <img class="detail-image" src="@/assets/goods/picture_ksdgfz01.png" />
                <img class="detail-image" src="@/assets/goods/picture_ksdgfz02.png" />
                <img class="detail-image" src="@/assets/goods/picture_ksdgfz03.png" />
                <img class="detail-image" src="@/assets/goods/picture_ksdgfz04.png" />
                <!-- 开启限时体验 不展示规则 -->
                <div v-if="!goodsLight.activityFlag" class="rule">
                    <img class="rule-title" src="@/assets/vipV3/icon_cjwt01.png" alt="">
                    <div class="rule-item">
                        <div class="rule-item-title">VIP 购买后可以退款吗?</div>
                        <div class="rule-item-content">VIP是虚拟商品，不支持退款哦。</div>
                    </div>
                    <div class="rule-item">
                        <div class="rule-item-title">有效期从什么时候开始算?</div>
                        <div class="rule-item-content">VIP服务有效期从您购买之日算起，有效期<b>{{goodsLight.effectiveDays}}</b>天。</div>
                    </div>
                    <div class="rule-item">
                        <div class="rule-item-title">我刚开通VIP为什么消失或者未生效?</div>
                        <div class="rule-item-content">请检查是否已经登录了账号，购买成功后,需要登录您的账号才能享受VIP服务。</div>
                    </div>
                    <div class="rule-item">
                        <div class="rule-item-title">其他问题及注意事项</div>
                        <div class="rule-item-content">购买前请注册/登录App账号，购买成功后，需要登录您购买时的账号才能享受VIP服务。如遇问题，可直接联系右上角帮助中的在线客服或者拨打客服电话咨询，我们会及时为您解答。</div>
                    </div>
                </div>
                <!-- 开启限时体验 不展示IOS支付 -->
                <div v-if="IOS && !goodsLight.activityFlag" class="pay-course" @click="iphonePayCourseVisible = true">iPhone支付教程</div>
            </div>
        </share-ad>
        <!--底部-->
        <div class="footer">
            <!-- 根据openMode来决定开通方式 开通方式 1-分享激活 2-支付 3-斑豆兑换 -->
            <div v-if="goodsLight.openMode === 1" class="share-type">限时领取<b>（分享激活）</b></div>
            <div v-else class="pay-type">
                <!-- 开启限时体验 不带单位 -->
                <div v-if="goodsLight.openMode === 2 && goodsLight.activityFlag" class="price"><span class="present">¥0</span><span class="origin">原价￥{{goodsLight.payOrigPrice}}</span></div>
                <!-- 原价 或者 斑豆-->
                <div v-else class="price">
                    <span class="present">
                        <!-- 金额支付模式 -->
                        <template v-if="goodsLight.openMode === 2">
                            <!-- 有优惠价就展示优惠价 -->
                            <template v-if="goodsLight.payConPrice">¥{{goodsLight.payConPrice}}</template>
                            <!-- 有斑豆就展示斑豆 -->
                            <template v-if="goodsLight.payConPoint">+{{goodsLight.payConPoint}}斑豆</template>
                            <!-- 没有优惠价就展示原价 -->
                            <template v-if="!goodsLight.payConPrice">¥{{goodsLight.payOrigPrice}}</template>
                        </template>
                        <template v-if="goodsLight.openMode === 3">{{goodsLight.pointNum}}斑豆</template>
                    </span>
                    <b class="unit">{{goodsLight.unit}}</b>
                    <!-- 如果选择的是优惠价 并且没有豆子就展示原价 -->
                    <span v-if="goodsLight.openMode === 2 && goodsLight.payConPrice && !goodsLight.payConPoint" class="origin">原价￥{{goodsLight.payOrigPrice}}</span>
                </div>
            </div>
            <!-- 根据状态展示展示对应的文本  -->
            <van-button v-if="Number(carType) === 1" :loading="loading" @click="submit">{{ (goodsLight.activityFlag || vipData.vipFlag) ? '立即体验' : {1:'立即开通', 2: '立即开通', 3:'立即开通'}[goodsLight.openMode] }}</van-button>
            <div v-else class="btn-none-buy">仅适用于C1/C2学员</div>
            <div v-if="goodsLight.activityFlag && timerStr" class="timer">
                <img src="@/assets/goods/icon_xshd.png" />
                <div class="timer-content">{{timerStr}}</div>
            </div>
        </div>
        <!--底部占位-->
        <div class="footer-pre"></div>
    </div>
    <!--消息弹出框-->
    <ctl-dialog v-model="messageDialog" :loading="loading"/>
    <!-- IOS支付教程 -->
    <iphonePayCourse v-if="iphonePayCourseVisible"></iphonePayCourse>
</div>
</template>
<script>
import dialog from '@/components/dialog/index.vue'
import { Toast, Button, Swipe, SwipeItem, ImagePreview } from 'vant'
import iphonePayCourse from '@/views/iphonePayCourse/index.vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
    name: 'goodsLightDetail',
    components: {
        ctlDialog: dialog,
        [Button.name]: Button,
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
        iphonePayCourse,
        Swiper,
        SwiperSlide
    },
    data () {
        return {
            // 车型默认小车
            carType: '1',
            // 分享数据
            shareData: {},
            // loading
            loading: false,
            // 显示分享
            shareVisible: false,
            // 头部显示
            headVisible: '',
            // app类型 1-定制版 2-学时版
            appType: '',
            // 苹果标记
            IOS: !!(navigator.userAgent).match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            // h5标记
            H5: false,
            carItems: [ // 车型大全图片
                'https://app.static.public.chetailian.com//1682504847176-icon_ljd.png?imageslim',
                'https://app.static.public.chetailian.com//1682504622609-icon_xrbig.png?imageslim',
                'https://app.static.public.chetailian.com//1682504866217-icon_lals.png?imageslim',
                'https://app.static.public.chetailian.com//1682504725279-icon_xjd.png?imageslim',
                'https://app.static.public.chetailian.com//1682504584927-icon_xstn.png?imageslim',
                'https://app.static.public.chetailian.com//1682504818982-icon_xals.png?imageslim',
                'https://app.static.public.chetailian.com//1682504914057-icon_dfrc.png?imageslim',
                'https://app.static.public.chetailian.com//1682504935281-icon_ftkll.png?imageslim',
                'https://app.static.public.chetailian.com//1682504939907-icon_gqcq.png?imageslim',
                'https://app.static.public.chetailian.com//1682504942287-icon_jldh.png?imageslim',
                'https://app.static.public.chetailian.com//1682504944909-icon_dfxtl.png?imageslim',
                'https://app.static.public.chetailian.com//1682504947637-icon_dzbl.png?imageslim',
            ],
            loopImages: [ // 中间轮播图片
                'https://app.static.public.chetailian.com//1682505220279-picture_slt01.png?imageslim',
                'https://app.static.public.chetailian.com//1682505225553-picture_slt02.png?imageslim',
                'https://app.static.public.chetailian.com//1682505230199-picture_slt03.png?imageslim',
                'https://app.static.public.chetailian.com//1682505236187-picture_slt04.png?imageslim',
                'https://app.static.public.chetailian.com//1682505241477-picture_slt05.png?imageslim',
                'https://app.static.public.chetailian.com//1682505245324-picture_slt06.png?imageslim',
            ],
            goodsLight: {},
            messageDialog: {},
            userInfo: {},
            vipData: {},
            timer: null,
            timerStr: '',
            iphonePayCourseVisible: false,
            swiperOptions: {
                slidesPerView: 3,
                centeredSlides: true,
                loop: true,
                autoplay: true
            }
        }
    },
    methods: {
        // 返回
        goBack () {
            this.$jsBridge.callBackHandler('returnLastPage')
        },
        // 联系客服
        pushCusService () {
            this.$jsBridge.callBackHandler('pushCusService')
        },
        // 打开分享面板
        openSharePanel () {
            // 标题
            let title = this.shareData.shareTitle || '科三灯光仿真训练'
            // 内容
            let content = '快来体验科三灯光仿真训练，轻松高效只要有手就会！'
            // 分享链接
            let shareUrl = ''
            // 图片链接
            let imageUrl = this.shareData.shareGroupImg
            // 页面编码
            let pageCode = 'light-detail'

            if (this.shareData.shareType === '1') {
                // 处理域名替换
                shareUrl = location.origin.replace('app.banbanjiadao.com', 'app.banbanjd.cn').replace('app.chetailian.com', 'app.banbanjd.cn')

                // 拼接路径
                shareUrl += location.pathname

                // 拼接参数
                shareUrl += `?shareType=h5&appType=${this.appType}`

                // 设置图片链接
                imageUrl = this.shareData.shareImg || 'http://app.static.public.chetailian.com/share/icon_ksdgmn.png'
            }

            // 唤起分享
            this.$jsBridge.callBackHandler('share', { title, content, shareUrl, imageUrl, pageCode })
        },
        // 获取分享配置信息
        getSetting () {
            this.$api.getAdSetting({ code: 'light-detail' }).then(res => {
                if (res.status && res.result) {
                    this.shareData = res.result
                }
            })
        },
        // 初始化
        init () {
            // app埋点
            this.$jsBridge.callBackHandler('onEventUM', { eventId: 'e_lights_detail_visit' })
            // 设置H5标记
            this.H5 = this.$route.query.shareType === 'h5'
            // 设置app类型
            this.appType = this.$jsBridge.callBackHandler('getAppType') || (typeof this.$route.query.appType === 'object' ? this.$route.query.appType[0] : this.$route.query.appType)
            // 设置分享显示
            this.shareVisible = !this.H5
            // 设置头部显示
            this.headVisible = this.$route.query.headShow || '1'
            // 暴露支付回调方法
            this.$jsBridge.registerHandler('payCallback', this.payCallback)
            // 暴露分享回调方法
            this.$jsBridge.registerHandler('shareCallback', this.shareCallback)
            // 返回页面触发回调
            this.$jsBridge.registerHandler('refreshCallBack', this.refreshCallBack)
        },
        // 跳转app
        linkApp () {
            // 判断设备
            if (this.IOS) {
                // qq浏览器特殊处理
                if (String(navigator.userAgent.toLowerCase().match(/QQ/i)) === 'qq') {
                    let body = document.querySelectorAll('body')[0]
                    let div = document.createElement('div')
                    let img = document.createElement('img')
                    div.style = 'width: 100%;position: fixed;height: 100%;top: 0;background: rgb(0 0 0 / 80%);z-index: 9;'
                    div.onclick = () => {
                        body.removeChild(div)
                    }
                    img.src = require('@/assets/public/icon_fxts.png')
                    img.style = 'width:100%'
                    div.appendChild(img)
                    body.appendChild(div)
                    return true
                }

                // 根据分享app类型跳转
                location.href = Number(this.appType) === 2
                    ? 'https://share.banbanjiadao.com/ui/h5/bbjd/index'
                    : 'https://share.banbanjiadao.com/ui/h5/bb/index'
            } else {
                // 根据分享app类型跳转
                location.href = Number(this.appType) === 2
                    ? 'https://a.app.qq.com/o/simple.jsp?pkgname=com.banbanjiadao.activity&android_schema=banbanjiadao%3a%2f%2fopen'
                    : 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ctl.student&android_schema=chetailian%3a%2f%2fopen&ios_scheme=chetailian%3a%2f%2fopen'
            }
        },
        // 跳转
        submit () {
            // H5标记不能购买
            if (this.H5) {
                this.linkApp()
                return
            }

            // 判断是否升级提示
            if (this.vipData.uploadAppFlag) {
                Toast.fail('VIP服务已升级，请升级APP获取更多服务！')
                return
            }

            // 已开通过vip的直接体验
            if (this.vipData.vipFlag || this.goodsLight.activityFlag) {
                if (this.goodsLight.activityFlag) {
                    // 点击灯光立即体验按钮 触发埋点
                    this.$jsBridge.callBackHandler('onEventUM', { eventId: 'e_lights_pay_click' })
                }
                // 除了IOS设备都需要登陆
                if (!this.IOS && !this.userInfo.userId) {
                    this.$jsBridge.callBackHandler('loginUserV2')
                    return
                }
                this.toPage()
                return
            }

            // 点击灯光立即开通按钮 触发埋点
            this.$jsBridge.callBackHandler('onEventUM', { eventId: 'e_lights_button_open' })

            // 班豆支付
            if (this.goodsLight.openMode === 3) {
                this.beanOpenModel()
            }
            // 金钱支付
            if (this.goodsLight.openMode === 2) {
                this.moneyOpenModel()
            }
            // 分享激活
            if (this.goodsLight.openMode === 1) {
                this.shareOpenModel()
            }
        },
        // 图片预览
        preview (index) {
            ImagePreview({
                images: this.loopImages,
                startPosition: index
            })
        },
        // 获取灯光仿真商品信息
        getGoodsInfo () {
            return this.$api.getVipGoodsLightInfo().then(res => {
                if (res.status) {
                    const { examVipLightSettingDTO, vipFlag } = res.result
                    examVipLightSettingDTO.unit = Number(examVipLightSettingDTO.effectiveDays) === 365 ? '/年' : `/${examVipLightSettingDTO.effectiveDays}天`
                    this.goodsLight = examVipLightSettingDTO
                    this.vipData = res.result
                    // 开通成功直接跳转到 灯光操作页面
                    if (vipFlag) {
                        this.toPage(true)
                    }
                    // 如果是开启限时功能 那就开始倒计时
                    if (examVipLightSettingDTO.activityFlag) {
                        this.countTimer()
                    }
                }
            })
        },
        // 斑豆开通方式
        beanOpenModel () {
            // 斑豆开通需要登陆
            if (!this.userInfo.userId) {
                this.$jsBridge.callBackHandler('loginUserV2')
                return
            }
            this.messageDialog = {
                title: '',
                content: '是否确认开通科三灯光仿真训练？',
                visible: true,
                rightBtnName: '确认',
                leftBtnName: '取消',
                leftBtnMethod: () => {
                    this.messageDialog.visible = false
                },
                rightBtnMethod: () => {
                    this.loading = true
                    this.$api.lightbbBeanOpen({ currentUserId: this.userInfo.userId }).then(res => {
                        this.loading = false
                        // 开通成功
                        if (res.result === null && res.status && res.code === '200') {
                            this.messageDialog.visible = false
                            this.getGoodsInfo()
                            Toast({
                                type: 'success',
                                message: '斑豆支付成功'
                            })
                        } else if (res.message.indexOf('斑豆不足') > -1) { // 斑豆异常处理
                            this.messageDialog = {
                                visible: true,
                                rightBtnName: '去做任务',
                                leftBtnName: '取消',
                                leftBtnMethod: () => {
                                    this.messageDialog.visible = false
                                },
                                rightBtnMethod: () => {
                                    this.messageDialog.visible = false

                                    // 跳转斑豆任务
                                    this.$jsBridge.callBackHandler('pushBandouCenterPage')
                                },
                                title: '',
                                content: res.message
                            }
                        } else if (res.code === '30003') { // 错误状态码处理
                            this.code30003(res.message)
                        } else if (res.code === '666' || res.code === '500') {
                            Toast.fail(res.message)
                        }
                    })
                }
            }
        },
        // 金钱开通方式
        moneyOpenModel () {
            // 除了IOS设备都需要登陆
            if (!this.IOS && !this.userInfo.userId) {
                this.$jsBridge.callBackHandler('loginUserV2')
                return
            }

            this.loading = true

            this.$api.lightpayOpen({ currentUserId: this.userInfo.userId }).then(res => {
                this.loading = false
                // 正常支付流程
                if (res.code === '200' && res.status) {
                    // 创建订单成功 触发埋点
                    this.$jsBridge.callBackHandler('onEventUM', { eventId: 'e_lights_order_success' })
                    // 判断是否IOS && 苹果支付
                    if (this.IOS) {
                        // 兼容ios
                        this.$jsBridge.callBackHandler('setApplePayType', { payType: 6 })
                        // 唤起苹果支付
                        this.$jsBridge.callBackHandler('applyPay', {
                            orderId: res.result,
                            productId: this.goodsLight.productId
                        })
                        return
                    }

                    // 安卓 跳转到订单支付页面
                    this.$router.push({
                        name: 'pay',
                        query: {
                            payId: res.result,
                            money: this.goodsLight.payConPrice > 0 ? this.goodsLight.payConPrice : this.goodsLight.payOrigPrice,
                            type: '9',
                            headShow: this.headVisible
                        }
                    })
                    return
                }
                // 错误状态码处理
                if (res.code === '30003') {
                    this.code30003(res.message)
                } else if (res.code === '701') {
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '去支付',
                        leftBtnName: '取消',
                        leftBtnMethod: () => {
                            this.messageDialog.visible = false
                        },
                        rightBtnMethod: () => {
                            this.messageDialog.visible = false
                            this.$router.push({
                                name: 'goodsLightOrderDetail',
                                query: { id: res.result, headShow: '1' }
                            })
                        },
                        title: '',
                        content: '您有灯光仿真VIP订单未支付'
                    }
                } else if (res.message.indexOf('斑豆不足') > -1) { // 斑豆异常处理
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '去做任务',
                        leftBtnName: '取消',
                        leftBtnMethod: () => {
                            this.messageDialog.visible = false
                        },
                        rightBtnMethod: () => {
                            this.messageDialog.visible = false

                            // 跳转斑豆任务
                            this.$jsBridge.callBackHandler('pushBandouCenterPage')
                        },
                        title: '',
                        content: res.message
                    }
                } else if (res.code === '666' || res.code === '500') { // 错误状态码处理
                    Toast.fail(res.message)
                }
            })
        },
        // 分享开通方式
        shareOpenModel () {
            // 分享开通需要登陆
            if (!this.userInfo.userId) {
                this.$jsBridge.callBackHandler('loginUserV2')
                return
            }

            // 标题
            let title = this.goodsLight.title
            // 内容
            let content = this.goodsLight.content
            // 分享链接
            let shareUrl = this.goodsLight.link
            // 图片链接
            let imageUrl = this.goodsLight.image
            // 页面编码
            let pageCode = 'light-detail'

            // 唤起分享
            this.$jsBridge.callBackHandler('share', { title, content, shareUrl, imageUrl, pageCode })
        },
        // 跳转到 灯光仿真操作页面
        /**
         * @param status {Boolean} 是否支付成功
         */
        toPage (status) {
            // 触发埋点 点击灯光仿真-考试车列表页面
            this.$jsBridge.callBackHandler('onEventUM', { eventId: ' e_lights_exam_visit' })
            if (status) { // 支付成功 触发埋点
                this.$jsBridge.callBackHandler('onEventUM', { eventId: 'e_lights_pay_success' })
            }
            // 进入到下一页时候 关闭当前页
            this.$jsBridge.callBackHandler('pushLightingRealisticPage')
        },
        /**
         * 支付回调
         * @param {Number} v 0:支付失败， 1:支付成功
         */
        payCallback (v) {
            // 未登录购买刷新数据
            if (Number(v) === 1 && !this.userInfo.userId) {
                this.getGoodsInfo()
                return
            }
            // 跳转支付结果页
            this.$router.push({ name: 'payResult', query: { result: v, headShow: '1' } })
        },
        // 分享后的回调
        shareCallback () {
            // 是否分享开通模式
            if (Number(this.goodsLight.openMode) !== 1) {
                return
            }
            this.loading = true
            this.$api.lightShareOpen({ shareRecordId: this.goodsLight.shareRecordId, times: '1' }).then(res => {
                this.loading = false
                if (res.status) {
                    Toast.success('分享成功')
                    // 分享成功 并且次数为0 重新请求
                    if (res.result === 0) {
                        this.getGoodsInfo()
                    }
                }
                if (res.code === '30003') {
                    this.code30003(res.message)
                } else if (res.code === '500') {
                    Toast.fail(res.message)
                }
            })
        },
        // 商品配置发生改变 状态码30003对时候 提示用户 并重新刷新
        code30003 (content) {
            this.getGoodsInfo()
            this.messageDialog = {
                visible: true,
                rightBtnName: '确定',
                rightBtnMethod: () => {
                    this.messageDialog.visible = false
                },
                title: '提示',
                content
            }
        },
        // 计时器 限时体验倒计时
        countTimer () {
            clearInterval(this.timer)
            const { activityEndTime } = this.goodsLight
            this.timer = setInterval(() => {
                const currentTime = Date.now()
                const { day, hour, minute } = this.moment.countDown(currentTime, activityEndTime)
                this.timerStr = `限时活动 ${day}天${hour}时${minute}分后结束`
                // 当前时间要是大于限时活动的结束时间 重新请求获取最新效果
                if (currentTime > activityEndTime) {
                    // 清空倒计时 并隐藏倒计时
                    this.timerStr = ''
                    this.goodsLight.activityFlag = false
                    // 在获取商品信息
                    this.getGoodsInfo()
                    clearInterval(this.timer)
                }
            }, 1000)
        },
        // 返回页面触发回调
        async refreshCallBack () {
            this.checkCarType()
            this.getUserInfo()
            await this.getGoodsInfo()
            // 如果登陆后 是限时体验 直接跳转到 考试车列表页
            if (this.goodsLight.activityFlag) {
                this.toPage()
            }
        },
        // 获取用户基本信息
        getUserInfo () {
            // 重新获取app用户数据
            const userInfo = this.$jsBridge.callBackHandler('passUserInfo')
            this.userInfo = userInfo ? JSON.parse(userInfo) : {}
            // 重新获取app token
            const ctlToken = this.$jsBridge.callBackHandler('passTokenData')
            if (ctlToken) {
                localStorage.setItem('ctl-token', JSON.parse(ctlToken).token)
            }
        },
        // 检查车型
        checkCarType () {
            // 设置车型
            this.carType = this.$jsBridge.callBackHandler('getBankCarType') || (this.$jsBridge.callBackHandler('getCarType') || '1')
            const carTypeName = this.$store.getters.carTypeName
            if (Number(this.carType) !== 1 && this.$jsBridge.hasNativeMethod('pushQuestionBankSettingPage')) {
                this.messageDialog = {
                    visible: true,
                    rightBtnName: '切换题库',
                    leftBtnName: '我知道了',
                    leftBtnMethod: () => {
                        this.messageDialog.visible = false
                    },
                    rightBtnMethod: () => {
                        this.messageDialog.visible = false

                        // 进入设置题库页面
                        this.$jsBridge.callBackHandler('pushQuestionBankSettingPage')
                    },
                    title: '温馨提示',
                    content: `该服务现仅适用于小车学员，您当前车型-${carTypeName[this.carType]}，是否需切换回小车题库？`
                }
            }
        }
    },
    mounted () {
        this.init()
        this.checkCarType()
        this.getUserInfo()
        this.getSetting()
        this.getGoodsInfo()
    },
    destroyed () {
        // 离开组件 销毁定时器
        clearInterval(this.timer)
    }
}
</script>
<style lang="scss" scoped>
    #wrapper{
        background-color: #feecde;
    }
    .header {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        display: flex;
        z-index: 2;
        align-items: center;
        justify-content: space-between;
        height: 44px;
        background: #ffffff;
        .header-main {
            font-size: 18px;
            font-weight: bold;
            color: #333333;
            line-height: 1;
            transform: translateY(3px);
        }
        .header-share {
            position: absolute;
            height: 44px;
            display: flex;
            align-items: center;
            right: 50px;
            font-size: 0;
            line-height: 1;
            img {
                width: 24px;
            }
        }
        .header-left, .header-right {
            display: flex;
            padding: 0 10px;
            font-size: 0;
            line-height: 1;
            img {
                width: 24px;
                height: 24px;
            }
        }
    }
    .header-pre {
        height: 44px;
    }
    .footer{
        display: flex;
        align-items: center;
        z-index: 2;
        position: fixed;
        bottom: 0;
        width: 100%;
        background: #ffffff;
        .share-type{
            flex: 1;
            font-size: 17px;
            font-weight: bold;
            color: #333333;
            text-align: center;
            b {
                font-size: 13px;
                font-weight: normal;
            }
        }
        .pay-type{
            display: flex;
            flex: 1;
            align-items: center;
            justify-content: center;
        }
        .price{
            display: flex;
            align-items: flex-end;
            justify-content: center;
            .present{
                font-weight: 600;
                color: #FF5050;
                font-size: 24px;
                line-height: 1;
            }
            .unit{
                color:#333;
                font-size: 15px;
                font-weight: normal;
            }
            .origin{
                margin-left: 5px;
                color: #999999;
                font-weight: normal;
                font-size: 15px;
                text-decoration: line-through;
            }
        }
        /deep/ .van-button {
            border: none;
            height: 49px;
            width: 120px;
            color:#A86F2F;
            background-color: #F5DDB6;
            font-size: 18px;
            font-weight: bold;
            border-radius: 0;
        }
        .btn-none-buy {
            padding:0 10px;
            height: 49px;
            line-height: 49px;
            font-size: 15px;
            font-weight: bold;
            color: #999999;
            background: #F0F0F0;
        }
    }
    .footer-pre {
        height: 49px;
    }
    .detail{
        position: relative;
        &-image{
            width: 100%;
            vertical-align: middle;
        }
        .swiper-image{
            position: absolute;
            top: 346px;
            left:50%;
            transform: translateX(-50%);
            width: 325px;
        }
        .swiper{
            padding:36px 0;
            font-size: 0;
            img {
                max-width: 100%;
                vertical-align: middle;
            }
            .swiper-item{
                position: relative;
                z-index: 4;
                transition: all 0.5s ease;
            }
            /deep/ .swiper-slide-active {
                z-index: 5;
                .swiper-item{
                    position: relative;
                    transform: scale(1.48);
                    &::after{
                        content: '';
                        position: absolute;
                        top:0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background: url('~@/assets/goods/icon_gx.png') no-repeat;
                        background-size: 100% 100%;
                    }
                }
            }
        }
        .loop-image{
            position: absolute;
            top: 705px;
            left:50%;
            transform: translateX(-50%);
            width: 325px;
            height: 183px;
        }
        /deep/ .van-swipe__indicator{
            width: 3px;
            height: 3px;
        }
        /deep/ .van-swipe__indicator--active {
            width: 6px;
            border-radius: 2px;
        }
        /deep/ .van-swipe__indicator:not(:last-child){
            margin-right: 3px;
        }
    }
    .timer{
        position: absolute;
        display: flex;
        align-items: flex-end;
        left: 23px;
        bottom: 100%;
        overflow: hidden;
        img {
            position: relative;
            z-index: 2;
            width: 75px;
        }
        &-content{
            padding: 0 11px 0 80px;
            height: 20px;
            color:#fff;
            font-size: 12px;
            line-height: 20px;
            border-radius: 5px;
            background-color: #FF5050;
            transform: translate(-75px, -4px);
        }
    }
    .rule {
        margin: 10px auto 15px;
        width: 355px;
        background: #FFF8F2;
        border-radius: 5px;
        padding-bottom: 20px;

        .rule-title {
            position: relative;
            top: -9px;
            display: block;
            margin: 0 auto 5px;
            width: 152px;
            height: 60px;
        }

        .rule-item {
            padding: 0 15px;

            .rule-item-title {
                background: url("~@/assets/vip/icon_wt01@2x.png") no-repeat left 2px;
                background-size: 16px;

                padding-left: 26px;
                line-height: 22px;
                font-size: 15px;
                font-weight: 600;
                color: #A6431B;
            }

            .rule-item-content {
                word-break: break-word;
                white-space: pre-line;
                margin-top: 10px;
                padding-left: 26px;
                font-size: 12px;
                font-weight: 400;
                color: #000000;
                line-height: 21px;

                b {
                    color: #FF5050;
                }
            }
        }

        .rule-item + .rule-item {
            margin-top: 20px;
        }
    }
    .pay-course {
        margin: 0 10px 15px 0;
        text-decoration: underline;
        font-size: 13px;
        color: #A6431B;
        text-align: right;
        line-height: 1;
    }

    .no-scroll {
        height: 100vh;
        overflow: hidden;
    }
</style>
